import { ParagraphNode, TextNode } from 'lexical';
import { HeadingNode, QuoteNode } from '@lexical/rich-text';
import { TableCellNode, TableNode, TableRowNode } from '@lexical/table';
import { AutoLinkNode, LinkNode } from '@lexical/link';
import { ListItemNode, ListNode } from '@lexical/list';
import { HorizontalRuleNode } from '@lexical/react/LexicalHorizontalRuleNode';
import { InlineImageNode } from './nodes/InlineImageNode';
import { InlineFrameNode } from './nodes/InlineFrameNode';
import { VariableNode } from './nodes/VariableNode';
import { LayoutContainerNode } from './plugins/LayoutPlugin/LayoutContainerNode';
import { LayoutItemNode } from './plugins/LayoutPlugin/LayoutItemNode';
import { VideoNode } from './nodes/VideoNode';

export const DEFAULT_NODES =
[
    HeadingNode,
    ParagraphNode,
    ListNode,
    ListItemNode,
    QuoteNode,
    TableCellNode,
    TableRowNode,
    TableNode,
    HorizontalRuleNode,
    TextNode,
    InlineImageNode,
    InlineFrameNode,
    VariableNode,
    LayoutContainerNode,
    LayoutItemNode,
    LinkNode,
    AutoLinkNode,
    VideoNode
];